import React from "react";

const CheckSign = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M18 7.893C12.427 7.893 7.893 12.427 7.893 18c0 5.573 4.534 10.107 10.107 10.107 5.573 0 10.107-4.534 10.107-10.107 0-5.573-4.534-10.107-10.107-10.107zm-1.777 14.68l-3.908-3.907 1.33-1.332 2.605 2.604 6.118-5.873 1.303 1.358-7.448 7.15z"
            fill={fill}
        />
        <path className="u_fill"
            d="M34 18c0-1.379-1.366-2.56-1.706-3.83-.351-1.316.23-3.02-.435-4.172-.677-1.168-2.45-1.511-3.397-2.46-.949-.948-1.292-2.72-2.46-3.397-1.152-.666-2.856-.084-4.171-.435C20.559 3.366 19.379 2 18 2s-2.56 1.366-3.83 1.706c-1.316.351-3.02-.23-4.171.435-1.169.677-1.512 2.45-2.46 3.397-.949.949-2.721 1.292-3.397 2.46-.667 1.152-.085 2.856-.436 4.171C3.366 15.441 2 16.621 2 18s1.366 2.56 1.706 3.83c.351 1.316-.23 3.02.435 4.171.677 1.169 2.45 1.512 3.397 2.46.949.949 1.292 2.721 2.46 3.397 1.152.667 2.856.085 4.171.436C15.441 32.634 16.621 34 18 34s2.56-1.366 3.83-1.706c1.316-.351 3.02.23 4.171-.435 1.169-.677 1.512-2.45 2.46-3.397.949-.949 2.721-1.292 3.397-2.46.667-1.152.085-2.856.436-4.171C32.634 20.559 34 19.379 34 18zM18 29.99c-6.61 0-11.99-5.38-11.99-11.99S11.39 6.01 18 6.01 29.99 11.39 29.99 18 24.61 29.99 18 29.99z"
            fill={fill}
        />
    </svg>
);

export default CheckSign;
